/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _typeof } from './dep-b333ab93.mjs';
import './dep-6f3e4f56.mjs';
import { e as eq_1 } from './dep-7211604f.mjs';
import { i as isArrayLike_1 } from './dep-372265bb.mjs';
import { _ as _isIndex } from './dep-52c1d6a9.mjs';
import { i as isObject_1 } from './dep-4efc69ee.mjs';
import './dep-97c71289.mjs';

var eq = eq_1,
  isArrayLike = isArrayLike_1,
  isIndex = _isIndex,
  isObject = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall;

export { _isIterateeCall as _ };
//# sourceMappingURL=dep-436b338d.mjs.map
